<pos-app-spinner [show]="(loadingCustomerDetails$ | async) || (loadingFetchingOrderFromJDE$ | async)"></pos-app-spinner>
<div
  class="container-fluid max1200"
  *ngIf="{ brandDefaults: brandDefaults$ | async
  } as data"
>
  <div *ngIf="data.brandDefaults?.showARBGiftCardSearchTF">
    <h3 class="text-center py-3 arb-large-heading">GIFT CARD BALANCE</h3>
    <div class="row p-3">
      <div class="col-3">
        <label>ARB GIFT CARD BALANCE:</label>
      </div>
      <div class="col-4">
        <input
          class="form-control"
          placeholder="Key or scan in gift card number"
          [(ngModel)]="giftCardNumber"
          (ngModelChange)="!giftCardNumber ? (giftCardBalance = undefined) : true"
        />
      </div>
      <div *ngIf="giftCardBalance != undefined && !giftCardErrorMessage" class="col-2">
        <input readonly class="form-control" value="${{ giftCardBalance ? (giftCardBalance | number : '1.2-2') : 0 }}" />
      </div>
      <div *ngIf="giftCardErrorMessage" class="col-2">
        <input readonly class="form-control" value="{{ giftCardErrorMessage }}" />
      </div>
      <div class="col d-flex justify-content-end">
        <button class="navlink btn" (click)="fetchCardBalance()" [disabled]="!giftCardNumber">
          FETCH BALANCE
          <pos-app-spinner2 *ngIf="isFetching$ | async"></pos-app-spinner2>
        </button>
      </div>
    </div>
    <hr />
  </div>
</div>
